import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LanguageModule } from '@language';
import { ShNotificationComponent } from '@stylehaven/components';
import { ErrorPageTemplate } from './error-page.template';
import { ErrorPageContainerComponent } from './error-page.container.component';

@Component({
    standalone: true,
    imports: [ShNotificationComponent, LanguageModule],
    selector: 'med-share-expired-container',
    template: ErrorPageTemplate,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpiredShareContainerComponent extends ErrorPageContainerComponent {
    protected title: string = 'components.share-expired.title';
    protected message: string = 'components.share-expired.message';
}
